import * as SelectPrimitive from '@radix-ui/react-select';
import type { ForwardedRef } from 'react';
import styled from 'styled-components';
import { theme } from './input_select.theme';

const elements = {
	separator: styled(SelectPrimitive.Separator)`
		height: 1px;
		background-color: ${theme.getValue('itemSeparatorBackground')};
		margin: ${theme.getValue('itemSeparatorSpacing')};
	`,
};

export function CellulaInputSelectSeparator(_: unknown, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return <elements.separator ref={ref} />;
}
